import { EventTypeGroup } from '../types/ViewModel/EventTypeGroup';
import { EventType } from '../types/ViewModel/EventType';
import EventTypeFactory from './EventTypeFactory';
import { RequiredConditionalMandatoryFactory } from './RequiredConditionalMandatoryFactory';
import { RotationTreeEnum } from '../enums/rotationTreeEnum';
import { EventTypeGroupBM } from '../types/BusinessModel/EventTypeGroupBM';

export default () => {
    const requiredConditionalMandatoryFactory = new RequiredConditionalMandatoryFactory();
    const { newEventType } = EventTypeFactory();

    const newEventTypeGroup = (eventTypeGroup: EventTypeGroupBM, levelId: RotationTreeEnum): EventTypeGroup | null => {
        let group: EventTypeGroup | null = null;
        if (eventTypeGroup) {
            group = createNewGroupItem(eventTypeGroup, levelId);
            if (group.eventTypeArray) {
                group.eventTypeArray.map((b) => {
                    b.eventTypeGroup = group;
                });
            }
        }
        return group;
    };

    const createNewGroupItem = (evTypeGr: EventTypeGroupBM, levelId: RotationTreeEnum): EventTypeGroup => {
        const eventTypeArray: EventType[] = [];
        evTypeGr.eventTypeList.map((evType) => {
            const item = newEventType(evType, levelId, evTypeGr.mandatory);
            if (item) {
                eventTypeArray.push(item);
            }
        });
        return new EventTypeGroup(
            evTypeGr.eventTypeGroupId,
            evTypeGr.name,
            evTypeGr.mandatory,
            evTypeGr.multiple,
            evTypeGr.concurrent,
            evTypeGr.generateConcurrentId,
            evTypeGr.showInPlanView,
            evTypeGr.ordered,
            evTypeGr.mainInLevel,
            evTypeGr.insideLevelBoundary,
            evTypeGr.nextGroupInLevelId,
            evTypeGr.requiredPreviousTypeId,
            evTypeGr.requiredPreviousSameTypeId,
            eventTypeArray,
            evTypeGr.icon,
            evTypeGr.notAfterEventTypeId,
            levelId,
            evTypeGr.requiredConditionalMandatoryList
                ? requiredConditionalMandatoryFactory.newRequiredConditionalMandatoryArray(
                      evTypeGr.requiredConditionalMandatoryList,
                      evTypeGr.eventTypeGroupId
                  )
                : null,
            evTypeGr.deleted,
            evTypeGr.enabledFrom,
            evTypeGr.useInSimpleMode,
            evTypeGr.onlyUseInSimpleMode
        );
    };

    const createUnknownEventTypeGroup = () => {
        return new EventTypeGroup(
            -1,
            'Unknown event group',
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            null,
            -1,
            null,
            [],
            null,
            null,
            null,
            null,
            false,
            null,
            null,
            null
        );
    };

    return {
        newEventTypeGroup,
        createNewGroupItem,
        createUnknownEventTypeGroup,
    };
};
